import asyncComponent from "../../../../shared/containers/asyncComponent";
export var MapInteractiveAsync = asyncComponent(function () {
    return new Promise(function (resolve) {
        import(/* webpackChunkName: "interactiveMap" */ "./mapInteractive").then(function (component) {
            resolve(component.MapInteractive);
        });
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/map/mapInteractiveAsync.ts
// module id = tgVK
// module chunks = 2